export default __webpack_public_path__ + "static/image-two-mobile-b4cade9971deb2b36f78946616f5df68.jpg";